/*
 * Pure RV cart drawer (replaces the AMP Slide Cart app, 2026-10-07).
 *
 * Contract with the rest of the theme: this file defines the same globals AMP
 * did (SLIDECART_OPEN / CLOSE / UPDATE / SET_CART / STATE / APPLY_DISCOUNT), so
 * the /cart/add interceptor in layout/theme.liquid and assets/prv2-home.js
 * drive it without any change. Adds from inside the drawer are plain fetch
 * POSTs to /cart/add.js, the same request the Meta pixel reads AddToCart from.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-prv-cd]');
  if (!root || window.__prvCartDrawer) return;
  window.__prvCartDrawer = true;

  var overlay = document.querySelector('[data-prv-cd-overlay]');
  var body = root.querySelector('[data-prv-cd-body]');
  var footer = root.querySelector('[data-prv-cd-footer]');
  var countEl = root.querySelector('[data-prv-cd-count]');
  var announceEl = root.querySelector('[data-prv-cd-announce]');
  var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';
  var upsellHandles = (root.getAttribute('data-upsells') || '').split(',').filter(Boolean);
  var hiddenHandles = (root.getAttribute('data-hidden-handles') || '').split(',').filter(Boolean);

  var UPSELL_COUNT = 4;
  var COUNTDOWN_MIN = 10;

  var state = { open: false, cart: null, busy: false, discountError: '', lastFocus: null };
  var productCache = {};
  var upsellCache = { key: '', products: [] };
  var queue = Promise.resolve();

  /* ------------------------------------------------------------ helpers */

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function money(cents) {
    cents = Math.round(cents || 0);
    function fmt(n, dec, th, ds) {
      var parts = (n / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(ds);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(cents, 0, '.', ',');
      return fmt(cents, 2, ',', '.');
    });
  }

  function img(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function json(url, opts) {
    opts = opts || {};
    opts.credentials = 'same-origin';
    opts.headers = Object.assign({ Accept: 'application/json' }, opts.headers || {});
    return fetch(url, opts).then(function (r) {
      return r.json().then(function (d) {
        if (!r.ok) throw d;
        return d;
      });
    });
  }

  function post(url, data) {
    return json(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
  }

  function fetchCart() {
    return json('/cart.js', { cache: 'no-store' });
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = json('/products/' + encodeURIComponent(handle) + '.js').catch(function () {
        delete productCache[handle];
        return null;
      });
    }
    return productCache[handle];
  }

  /* Serialise every cart write so fast double-clicks cannot interleave. */
  function mutate(fn) {
    queue = queue.then(function () {
      setBusy(true);
      return fn();
    }).then(function (cart) {
      return cart && cart.items ? cart : fetchCart();
    }).then(function (cart) {
      return render(cart);
    }).catch(function () {
      return fetchCart().then(render);
    }).then(function () {
      setBusy(false);
      document.dispatchEvent(new CustomEvent('cart:updated'));
    });
    return queue;
  }

  function setBusy(on) {
    state.busy = on;
    root.classList.toggle('is-busy', on);
  }

  /* ---------------------------------------------------------- countdown */

  var timer = null;
  function deadline() {
    var d = 0;
    try { d = parseInt(sessionStorage.getItem('prvCdDeadline'), 10) || 0; } catch (e) {}
    if (!d || d < Date.now()) {
      d = Date.now() + COUNTDOWN_MIN * 60000;
      try { sessionStorage.setItem('prvCdDeadline', String(d)); } catch (e) {}
    }
    return d;
  }
  function tick() {
    var ms = Math.max(0, deadline() - Date.now());
    var m = Math.floor(ms / 60000);
    var s = Math.floor((ms % 60000) / 1000);
    announceEl.textContent = 'Checkout in ⏰ ' + (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s + ' minutes to keep your cart';
  }
  function runCountdown(on) {
    clearInterval(timer);
    announceEl.hidden = !on;
    if (!on) return;
    tick();
    timer = setInterval(tick, 1000);
  }

  /* -------------------------------------------------------------- render */

  function lineHtml(item, index, product) {
    var variant = product && product.variants.filter(function (v) { return v.id === item.variant_id; })[0];
    var unitRef = Math.max(variant ? variant.compare_at_price || 0 : 0, variant ? variant.price : 0, item.original_price);
    var compareLine = unitRef * item.quantity;
    var now = item.final_line_price;
    var save = compareLine - now;

    var props = '';
    Object.keys(item.properties || {}).forEach(function (k) {
      var v = item.properties[k];
      if (!v || k.charAt(0) === '_') return;
      props += '<div class="prv-cd__meta">' + esc(k) + ': ' + esc(v) + '</div>';
    });

    var variantLine = item.product_has_only_default_variant ? '' : '<div class="prv-cd__meta">' + esc(item.variant_title) + '</div>';

    return (
      '<div class="prv-cd__item" data-key="' + esc(item.key) + '" data-line="' + (index + 1) + '">' +
        '<a class="prv-cd__img" href="' + esc(item.url) + '">' +
          (item.image ? '<img src="' + esc(img(item.image, 200)) + '" alt="' + esc(item.product_title) + '" width="100" height="100" loading="lazy">' : '') +
        '</a>' +
        '<div class="prv-cd__main">' +
          '<div class="prv-cd__top">' +
            '<div>' +
              '<a class="prv-cd__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
              variantLine +
              '<div class="prv-cd__meta">Vendor: ' + esc(item.vendor) + '</div>' +
              props +
            '</div>' +
            '<button type="button" class="prv-cd__remove" data-act="remove" aria-label="Remove ' + esc(item.product_title) + '">' +
              '<svg aria-hidden="true" width="9" viewBox="0 0 10 10"><path d="M9.677 8.118a1.102 1.102 0 11-1.559 1.56L5 6.558 1.882 9.677a1.102 1.102 0 11-1.56-1.559L3.442 5 .323 1.882A1.102 1.102 0 111.882.322L5 3.442 8.118.323a1.102 1.102 0 111.56 1.559L6.558 5l3.118 3.118z" fill="#1b2d2a"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="prv-cd__bottom">' +
            '<div class="prv-cd__qty">' +
              '<button type="button" data-act="dec" aria-label="Decrease quantity">−</button>' +
              '<input type="number" min="0" inputmode="numeric" value="' + item.quantity + '" data-act="qty" aria-label="Quantity">' +
              '<button type="button" data-act="inc" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<div class="prv-cd__prices">' +
              (save > 0 ? '<span class="prv-cd__compare"><span class="visually-hidden">Original price</span>' + money(compareLine) + '</span>' : '') +
              '<span class="prv-cd__now">' + money(now) + '</span>' +
              (save > 0 ? '<div class="prv-cd__save">You save ' + money(save) + '</div>' : '') +
            '</div>' +
          '</div>' +
          subscriptionHtml(item, product, variant) +
        '</div>' +
      '</div>'
    );
  }

  /*
   * Subscribe & save, per line. Shows only when the product actually has a
   * selling plan (Shopify Subscriptions app); until a plan exists it renders
   * nothing. The dollar figure is the real per-line difference Shopify will
   * charge, read from the variant's selling_plan_allocations.
   */
  /*
   * Which delivery interval to suggest. Tank treatments get reordered about
   * every 50 days (owner's order data, 2026-10-08), so the plan whose interval
   * is closest to that is the one offered first. Interval is read from the
   * plan name ("Deliver every 2 months, 15% off"); unknown names count as 30.
   */
  var REORDER_DAYS = 50;
  function planDays(name) {
    var m = String(name || '').toLowerCase().match(/(\d+)?\s*(day|week|month)/);
    if (!m) return 30;
    var n = parseInt(m[1], 10) || 1;
    return n * (m[2] === 'day' ? 1 : m[2] === 'week' ? 7 : 30);
  }
  function pickPlan(plans) {
    return plans.slice().sort(function (a, b) {
      return Math.abs(planDays(a.name) - REORDER_DAYS) - Math.abs(planDays(b.name) - REORDER_DAYS);
    })[0];
  }
  function shortPlan(name) {
    var m = String(name || '').match(/every\s+[^,]+/i);
    return m ? m[0].toLowerCase() : '';
  }

  function subscriptionHtml(item, product, variant) {
    if (!product || !variant || !product.selling_plan_groups || !product.selling_plan_groups.length) return '';
    var allocs = variant.selling_plan_allocations || [];
    if (!allocs.length) return '';

    var plans = [];
    product.selling_plan_groups.forEach(function (g) {
      (g.selling_plans || []).forEach(function (p) {
        var a = allocs.filter(function (x) { return x.selling_plan_id === p.id; })[0];
        if (a) plans.push({ id: p.id, name: p.name, price: a.price });
      });
    });
    if (!plans.length) return '';

    if (item.selling_plan_allocation) {
      var cur = item.selling_plan_allocation.selling_plan.id;
      var opts = plans.map(function (p) {
        return '<option value="' + p.id + '"' + (p.id === cur ? ' selected' : '') + '>' + esc(p.name) + '</option>';
      }).join('');
      return (
        '<div class="prv-cd__sub prv-cd__subon">' +
          '<span>Subscription:</span>' +
          (plans.length > 1 ? '<select data-act="plan" aria-label="Delivery frequency">' + opts + '</select>' : '<span>' + esc(plans[0].name) + '</span>') +
          (product.requires_selling_plan ? '' : '<button type="button" data-act="onetime">Switch to one-time</button>') +
        '</div>'
      );
    }

    var best = pickPlan(plans);
    var saveEach = variant.price - best.price;
    var when = shortPlan(best.name);
    var label = (saveEach > 0
      ? 'Subscribe & save ' + money(saveEach * item.quantity) + ' on this item'
      : 'Upgrade to Subscription') + (when ? ' · delivered ' + when : '');
    return (
      '<div class="prv-cd__sub">' +
        '<button type="button" class="prv-cd__subbtn" data-act="subscribe" data-plan="' + best.id + '">' + esc(label) + '</button>' +
      '</div>'
    );
  }

  function upsellHtml(products) {
    if (!products.length) return '';
    return (
      '<div class="prv-cd__ups">' +
        '<h3>You might also like</h3>' +
        '<div class="prv-cd__track">' +
          products.map(function (p) {
            var avail = p.variants.filter(function (v) { return v.available; });
            var v = avail[0];
            var cmp = Math.max(v.compare_at_price || 0, 0);
            var select = avail.length > 1
              ? '<select data-ups-variant aria-label="Choose option">' + avail.map(function (x) {
                  return '<option value="' + x.id + '">' + esc(x.title) + ' - ' + money(x.price) + '</option>';
                }).join('') + '</select>'
              : '';
            return (
              '<div class="prv-cd__card">' +
                '<img src="' + esc(img(p.featured_image, 300)) + '" alt="' + esc(p.title) + '" width="120" height="120" loading="lazy">' +
                '<a href="' + esc(p.url || '/products/' + p.handle) + '">' + esc(p.title) + '</a>' +
                '<div class="prv-cd__cardprice">' +
                  (cmp > v.price ? '<span class="prv-cd__compare">' + money(cmp) + '</span>' : '') +
                  '<span class="prv-cd__now">' + money(v.price) + '</span>' +
                '</div>' +
                select +
                '<button type="button" data-ups-add data-variant="' + v.id + '">Add</button>' +
              '</div>'
            );
          }).join('') +
        '</div>' +
      '</div>'
    );
  }

  function discountHtml(cart) {
    var chips = (cart.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) {
      return '<span class="prv-cd__chip">' + esc(d.code) + '<button type="button" data-disc-remove="' + esc(d.code) + '" aria-label="Remove discount ' + esc(d.code) + '">×</button></span>';
    }).join('');
    return (
      '<div class="prv-cd__disc">' +
        '<form class="prv-cd__discform" data-disc-form>' +
          '<input type="text" name="code" placeholder="Discount code" aria-label="Discount code" autocomplete="off" autocapitalize="characters">' +
          '<button type="submit">Apply</button>' +
        '</form>' +
        (state.discountError ? '<div class="prv-cd__discerr" role="alert">' + esc(state.discountError) + '</div>' : '') +
        (chips ? '<div class="prv-cd__chips">' + chips + '</div>' : '') +
      '</div>'
    );
  }

  function footerHtml(cart, originalTotal) {
    var save = originalTotal - cart.total_price;
    return (
      (cart.total_discount > 0
        ? '<div class="prv-cd__discrow"><span>Discounts</span><span>-' + money(cart.total_discount) + '</span></div>'
        : '') +
      '<div class="prv-cd__row">' +
        '<strong>Subtotal</strong>' +
        '<div class="prv-cd__totals">' +
          (save > 0 ? '<span class="prv-cd__compare"><span class="visually-hidden">Original price</span>' + money(originalTotal) + '</span>' : '') +
          '<strong>' + money(cart.total_price) + '</strong>' +
          (save > 0 ? '<div class="prv-cd__save">You save ' + money(save) + '</div>' : '') +
        '</div>' +
      '</div>' +
      '<button type="button" class="prv-cd__checkout" data-prv-cd-checkout>Checkout</button>'
    );
  }

  function render(cart) {
    if (!cart || !cart.items) return Promise.resolve();
    state.cart = cart;
    countEl.textContent = cart.item_count;

    if (!cart.item_count) {
      runCountdown(false);
      footer.hidden = true;
      body.innerHTML =
        '<div class="prv-cd__empty"><p>Your cart is empty</p>' +
        '<button type="button" class="prv-cd__shop" data-prv-cd-close>Shop now</button></div>';
      return Promise.resolve();
    }

    var handles = cart.items.map(function (it) { return it.handle; });
    return Promise.all(handles.map(getProduct)).then(function (products) {
      var originalTotal = 0;
      var lines = cart.items.map(function (item, i) {
        var p = products[i];
        var v = p && p.variants.filter(function (x) { return x.id === item.variant_id; })[0];
        originalTotal += Math.max(v ? v.compare_at_price || 0 : 0, v ? v.price : 0, item.original_price) * item.quantity;
        return lineHtml(item, i, p);
      }).join('');

      return loadUpsells(cart).then(function (ups) {
        var keepScroll = body.scrollTop;
        var trackScroll = (body.querySelector('.prv-cd__track') || {}).scrollLeft || 0;
        body.innerHTML = lines + upsellHtml(ups) + discountHtml(cart);
        body.scrollTop = keepScroll;
        var track = body.querySelector('.prv-cd__track');
        if (track) track.scrollLeft = trackScroll;
        footer.innerHTML = footerHtml(cart, originalTotal);
        footer.hidden = false;
        if (state.open) runCountdown(true);
      });
    });
  }

  /* ------------------------------------------------------------- upsells */

  /*
   * Same source AMP used: Shopify's own "related" recommendations for the most
   * recently added product, minus anything already in the cart, topped up from
   * the merchant list AMP had configured.
   */
  function loadUpsells(cart) {
    var inCart = cart.items.map(function (it) { return it.product_id; });
    var seed = cart.items[0].product_id;
    var key = seed + '|' + inCart.join(',');
    if (upsellCache.key === key) return Promise.resolve(upsellCache.products);

    return json('/recommendations/products.json?limit=10&intent=related&product_id=' + seed)
      .then(function (d) { return d.products || []; })
      .catch(function () { return []; })
      .then(function (recs) {
        return Promise.all(upsellHandles.map(getProduct)).then(function (fixed) {
          var seen = {};
          var out = [];
          recs.concat(fixed).forEach(function (p) {
            if (!p || seen[p.id] || out.length >= UPSELL_COUNT) return;
            seen[p.id] = true;
            if (inCart.indexOf(p.id) > -1) return;
            if (hiddenHandles.indexOf(p.handle) > -1) return;
            if (p.requires_selling_plan) return;
            if (!p.variants || !p.variants.some(function (v) { return v.available; })) return;
            out.push(p);
          });
          upsellCache = { key: key, products: out };
          return out;
        });
      });
  }

  /* -------------------------------------------------------------- actions */

  function changeLine(key, qty) {
    return mutate(function () {
      return post('/cart/change.js', { id: key, quantity: Math.max(0, qty) });
    });
  }

  function setPlan(item, planId) {
    return mutate(function () {
      return post('/cart/change.js', { id: item.key, quantity: item.quantity, selling_plan: planId });
    });
  }

  function addVariant(id, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    /* A real POST to /cart/add.js: the theme's fetch wrapper re-opens and
       refreshes this drawer, and the Meta pixel records AddToCart. */
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    }).then(function () {
      return update();
    }).catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'Add'; }
    });
  }

  /*
   * Last-chance Subscribe & Save offer on the way to checkout. Shopify only
   * lets Plus stores add anything to the checkout page itself (this store is
   * on Basic), so the offer is made here, one click before it. Shown once per
   * session; "No thanks" goes straight to checkout.
   */
  var pendingOffer = null;

  function eligibleLines() {
    if (!state.cart) return Promise.resolve([]);
    var lines = state.cart.items.filter(function (it) { return !it.selling_plan_allocation; });
    return Promise.all(lines.map(function (it) { return getProduct(it.handle); })).then(function (products) {
      var out = [];
      lines.forEach(function (it, i) {
        var p = products[i];
        var v = p && p.variants.filter(function (x) { return x.id === it.variant_id; })[0];
        var plans = [];
        ((p && p.selling_plan_groups) || []).forEach(function (g) {
          (g.selling_plans || []).forEach(function (sp) {
            var al = v && (v.selling_plan_allocations || []).filter(function (x) { return x.selling_plan_id === sp.id; })[0];
            if (al) plans.push({ id: sp.id, name: sp.name, price: al.price });
          });
        });
        if (!plans.length) return;
        var bp = pickPlan(plans);
        var a = { selling_plan_id: bp.id, price: bp.price };
        var save = (v.price - a.price) * it.quantity;
        if (save > 0) out.push({ item: it, plan: a.selling_plan_id, when: shortPlan(bp.name), save: save });
      });
      return out;
    });
  }

  function offerSeen() {
    try { return sessionStorage.getItem('prvCdOfferSeen') === '1'; } catch (e) { return false; }
  }

  function markOfferSeen() {
    try { sessionStorage.setItem('prvCdOfferSeen', '1'); } catch (e) {}
  }

  function goCheckout() {
    window.location.href = '/checkout';
  }

  function checkout() {
    if (offerSeen()) return goCheckout();
    eligibleLines().then(function (lines) {
      if (!lines.length) return goCheckout();
      pendingOffer = lines;
      var total = lines.reduce(function (n, l) { return n + l.save; }, 0);
      footer.innerHTML =
        '<div class="prv-cd__offer" role="dialog" aria-label="Subscribe and save">' +
          '<p class="prv-cd__offer-title">Save ' + money(total) + ' on this order</p>' +
          '<p class="prv-cd__offer-text">Switch to Subscribe &amp; Save for 15% off every delivery' + (lines[0].when ? ', delivered ' + lines[0].when : '') + '. Skip or cancel anytime from your account.</p>' +
          '<button type="button" class="prv-cd__checkout" data-prv-cd-offer-yes>Yes, subscribe &amp; save ' + money(total) + '</button>' +
          '<button type="button" class="prv-cd__offer-no" data-prv-cd-offer-no>No thanks, continue to checkout</button>' +
        '</div>';
      var yes = footer.querySelector('[data-prv-cd-offer-yes]');
      if (yes) yes.focus({ preventScroll: true });
    });
  }

  function acceptOffer() {
    markOfferSeen();
    var lines = pendingOffer || [];
    var yes = footer.querySelector('[data-prv-cd-offer-yes]');
    if (yes) { yes.disabled = true; yes.textContent = 'Switching...'; }
    var chain = Promise.resolve();
    lines.forEach(function (l) {
      chain = chain.then(function () {
        return post('/cart/change.js', { id: l.item.key, quantity: l.item.quantity, selling_plan: l.plan });
      });
    });
    chain.then(goCheckout, goCheckout);
  }

  function declineOffer() {
    markOfferSeen();
    goCheckout();
  }

  function currentCodes() {
    return ((state.cart && state.cart.discount_codes) || []).map(function (d) { return d.code; });
  }

  function applyDiscount(code) {
    code = String(code || '').trim();
    if (!code) return Promise.resolve();
    state.discountError = '';
    var codes = currentCodes().filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    return mutate(function () {
      return post('/cart/update.js', { discount: codes.join(',') })
        .catch(function () {
          return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).then(fetchCart);
        })
        .then(function (cart) {
          var hit = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === code.toLowerCase(); })[0];
          if (hit && hit.applicable) return cart;
          state.discountError = 'Invalid discount code';
          var keep = (cart.discount_codes || []).map(function (d) { return d.code; })
            .filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
          return post('/cart/update.js', { discount: keep.join(',') });
        });
    });
  }

  function removeDiscount(code) {
    state.discountError = '';
    var keep = currentCodes().filter(function (c) { return c !== code; });
    return mutate(function () {
      return post('/cart/update.js', { discount: keep.join(',') });
    });
  }

  function itemFor(el) {
    var row = el.closest('[data-key]');
    if (!row || !state.cart) return null;
    var key = row.getAttribute('data-key');
    return state.cart.items.filter(function (it) { return it.key === key; })[0] || null;
  }

  root.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-prv-cd-close]')) { e.preventDefault(); close(); return; }
    if (t.closest('[data-prv-cd-checkout]')) { e.preventDefault(); checkout(); return; }
    if (t.closest('[data-prv-cd-offer-yes]')) { e.preventDefault(); acceptOffer(); return; }
    if (t.closest('[data-prv-cd-offer-no]')) { e.preventDefault(); declineOffer(); return; }

    var ups = t.closest('[data-ups-add]');
    if (ups) {
      var card = ups.closest('.prv-cd__card');
      var sel = card && card.querySelector('[data-ups-variant]');
      addVariant(sel ? sel.value : ups.getAttribute('data-variant'), ups);
      return;
    }

    var dr = t.closest('[data-disc-remove]');
    if (dr) { removeDiscount(dr.getAttribute('data-disc-remove')); return; }

    var act = t.closest('[data-act]');
    if (!act || state.busy) return;
    var item = itemFor(act);
    if (!item) return;
    var a = act.getAttribute('data-act');
    if (a === 'remove') changeLine(item.key, 0);
    else if (a === 'inc') changeLine(item.key, item.quantity + 1);
    else if (a === 'dec') changeLine(item.key, item.quantity - 1);
    else if (a === 'subscribe') setPlan(item, Number(act.getAttribute('data-plan')));
    else if (a === 'onetime') setPlan(item, null);
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    var item = itemFor(t);
    if (!item) return;
    if (t.matches('[data-act="qty"]')) {
      var q = parseInt(t.value, 10);
      if (isNaN(q) || q === item.quantity) { t.value = item.quantity; return; }
      changeLine(item.key, q);
    } else if (t.matches('[data-act="plan"]')) {
      setPlan(item, Number(t.value));
    }
  });

  root.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-disc-form]');
    if (!f) return;
    e.preventDefault();
    e.stopPropagation();
    applyDiscount(f.querySelector('input').value);
  });

  overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) close();
  });

  /* ---------------------------------------------------------- open/close */

  function open() {
    if (!state.open) {
      state.lastFocus = document.activeElement;
      state.open = true;
      root.classList.add('is-open');
      overlay.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('prv-cd-lock');
      var c = root.querySelector('.prv-cd__close');
      if (c) setTimeout(function () { c.focus({ preventScroll: true }); }, 50);
    }
    runCountdown(!!(state.cart && state.cart.item_count));
    return Promise.resolve();
  }

  function close() {
    if (!state.open) return;
    state.open = false;
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('prv-cd-lock');
    runCountdown(false);
    if (state.lastFocus && state.lastFocus.focus) {
      try { state.lastFocus.focus({ preventScroll: true }); } catch (e) {}
    }
  }

  function update(cart) {
    if (cart && cart.items) return render(cart);
    return fetchCart().then(render).catch(function () {});
  }

  /* --------------------------------------------- AMP-compatible globals */

  window.SLIDECART_OPEN = function () { return update().then(open); };
  window.SLIDECART_CLOSE = close;
  window.SLIDECART_UPDATE = update;
  window.SLIDECART_SET_CART = function (cart) { return update(cart); };
  window.SLIDECART_APPLY_DISCOUNT = applyDiscount;
  window.SLIDECART_STATE = function () { return { open: state.open, isOpen: state.open, cart: state.cart }; };

  update();
})();
